import styled, { css } from "styled-components";

export const Container = styled.div`
  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue",
    Arial, "System San Francisco Display Regular", sans-serif;
  font-weight: 400;
  max-width: 618px;
  display: block;
  width: 100%;
  background: #fff;
  margin: 0 auto;
  line-height: 1.4em;
  text-align: left;
  padding: 10px;
  border-radius: 10px;

  a {
    color: blue;
  }

  ul {
    list-style-type: disc;
    margin-left: 20px;
  }

  &:hover {
    background-color: #f2f2f2;
  }

  ${(props) =>
    props.isEmpty &&
    css`
      .empty-view {
        display: block;
        margin-top: -30px;
        opacity: 0.5;
      }
    `}
`;

export const EmptyView = styled.div`
  font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue",
    Arial, "System San Francisco Display Regular", sans-serif;
  font-weight: 400;
  max-width: 618px;
  display: none;
  line-height: 1.4em;
`;
